import { EMPTY_SCAFFOLD_SELECTION } from "../interface";
import { IScaffoldActionRowClicked, ScaffoldState } from "./interface";
import {
  addRowRangeToSelection,
  setRowRangeSelection,
  toggleRowInSelection,
} from "./scaffoldSelection";

/**
 * Handles the ROW_CLICKED action by updating the selection state based on the
 * modifier keys held during the click.
 *
 * - Shift+click with a row anchor: range-selects from the anchor to the clicked row.
 * - Ctrl/Meta+click: toggles the clicked row in the selection and sets the anchor.
 * - Plain click: selects only the clicked row and sets the anchor.
 *
 * @param action - The ROW_CLICKED action carrying the row ID and modifier keys.
 * @param state - The current scaffold state.
 * @returns Updated scaffold state with the new selection and anchor.
 */
export const scr_rowClicked = <T>(
  action: IScaffoldActionRowClicked,
  state: ScaffoldState<T>,
): ScaffoldState<T> => {
  const { rowId, ctrlKey, metaKey, shiftKey } = action;
  const { selection, selectionAnchor, prevRows } = state;

  if (shiftKey) {
    if (selectionAnchor && selectionAnchor.type === "row") {
      return {
        ...state,
        selection:
          ctrlKey || metaKey
            ? addRowRangeToSelection(selection, prevRows, selectionAnchor.rowId, rowId)
            : setRowRangeSelection(prevRows, selectionAnchor.rowId, rowId),
      };
    }
    return {
      ...state,
      selection: { ...EMPTY_SCAFFOLD_SELECTION, selectedRows: [{ firstCellId: rowId }] },
      selectionAnchor: { type: "row", rowId },
    };
  }

  return {
    ...state,
    selection:
      ctrlKey || metaKey
        ? toggleRowInSelection(selection, rowId)
        : { ...EMPTY_SCAFFOLD_SELECTION, selectedRows: [{ firstCellId: rowId }] },
    selectionAnchor: { type: "row", rowId },
  };
};
